<app-expansion-panel i18n-title title="Documents contractuels">
  <!-- A direct child of the panel, hidden rather than removed: see the cancellation request info's « Modifier ». -->
  <button
    expansionPanelHeaderActions
    type="button"
    class="lty-btn lty-btn-white lty-btn-sm"
    [hidden]="!canEdit || (!policyProposalId && !running)"
    (click)="documentModal.openModal(running ?? null, policyProposalId)"
    i18n
  >
    Ajouter un document
  </button>
  <ul class="policy-documents">
    @for (
      doc of proposal?.policyDetails?.policyDocs;
      track doc;
      let idx = $index;
      let count = $count
    ) {
      <li
        (click)="viewFile(doc)"
        class="clickable"
        (keydown.enter)="viewFile(doc)"
        (keydown.space)="viewFile(doc)"
        tabindex="0"
        role="button"
      >
        <app-file-alternate-icon height="16px" width="16px" />
        <span class="document-name">
          <ng-container i18n>Document offre</ng-container>
          @if (count > 1) {
            <ng-container> {{ idx + 1 }}</ng-container>
          }
        </span>
        <div class="lty-badge" i18n>Offre</div>
      </li>
    }
    @if (proposal.policyDetails?.categoryDetails?.documents?.length > 0) {
      @for (
        doc of proposal.policyDetails.categoryDetails.documents;
        track doc
      ) {
        <li
          (click)="viewFile(doc.link)"
          class="clickable"
          (keydown.enter)="viewFile(doc.link)"
          (keydown.space)="viewFile(doc.link)"
          tabindex="0"
          role="button"
        >
          <app-file-alternate-icon height="16px" width="16px" />
          <span class="document-name">{{ doc.documentName }}</span>
          <div class="lty-badge" i18n>CGA</div>
        </li>
      }
    }
    @if (signedOfferDocument) {
      <li
        (click)="viewFile(getSignedOfferDocumentKey())"
        class="clickable"
        (keydown.enter)="viewFile(getSignedOfferDocumentKey())"
        (keydown.space)="viewFile(getSignedOfferDocumentKey())"
        tabindex="0"
        role="button"
      >
        <app-file-alternate-icon height="16px" width="16px" />
        <span class="document-name">
          @if (
            signedOfferDocument.docName || signedOfferDocument.originalFileName
          ) {
            {{
              signedOfferDocument.docName ||
                signedOfferDocument.originalFileName
            }}
          } @else {
            <ng-container i18n>Offre signée</ng-container>
          }
        </span>
        <div class="lty-badge" i18n>Offre signée</div>
        @if (signedOfferDocument.uploadedOn) {
          <span class="metadata-info">
            <ng-container i18n>Dépôt : </ng-container>
            {{ signedOfferDocument.uploadedOn | date: DATE_FORMAT }}
          </span>
        }
        @if (proposal.offerSignatureDate) {
          <span class="metadata-info">
            <ng-container i18n>Signature : </ng-container>
            {{ proposal.offerSignatureDate | date: DATE_FORMAT }}
          </span>
        }
      </li>
    }
    @for (
      doc of proposal?.contractDoc;
      track doc;
      let idx = $index;
      let count = $count
    ) {
      <li
        (click)="viewFile(doc)"
        class="clickable"
        (keydown.enter)="viewFile(doc)"
        (keydown.space)="viewFile(doc)"
        tabindex="0"
        role="button"
      >
        <app-file-alternate-icon height="16px" width="16px" />
        <span class="document-name">
          <ng-container i18n>Document de la police</ng-container>
          @if (count > 1) {
            <ng-container> {{ idx + 1 }}</ng-container>
          }
        </span>
        <div class="lty-badge" i18n>Police</div>
      </li>
    }
    <!-- The opened flow's cancellations, in their panels' order, each one's newest first. -->
    @for (cancellation of cancellations(); track cancellation.id) {
      @for (document of cancellation.documents; track document.documentId) {
        <!-- The name opens the file, the trash removes it: two controls, so neither is the row. -->
        <li
          [class.cancellation-document--called-off]="isCalledOff(cancellation)"
        >
          <app-file-alternate-icon height="16px" width="16px" />
          @if (document.url; as url) {
            <span
              class="document-name clickable"
              role="button"
              tabindex="0"
              (click)="viewFile(url)"
              (keydown.enter)="viewFile(url)"
              (keydown.space)="viewFile(url)"
              >{{ document.name }}</span
            >
          } @else {
            <span class="document-name">{{ document.name }}</span>
          }
          <div class="lty-badge" [class.gray]="isCalledOff(cancellation)">
            {{ typeLabel(document.type) }}
          </div>
          <span class="metadata-info">
            <ng-container i18n>Date dépôt</ng-container> :
            {{ document.createdOn | date: DATE_FORMAT }}
          </span>
          @if (document.letterDate; as letterDate) {
            <span class="metadata-info">
              <ng-container i18n>Date lettre</ng-container> :
              {{ letterDate | date: DATE_FORMAT }}
            </span>
          }
          <span class="metadata-info">{{
            cancellationLabel(cancellation)
          }}</span>
          @if (isCalledOff(cancellation)) {
            <span class="metadata-info" i18n>Résiliation annulée</span>
          }
          @if (canEdit && cancellation === running) {
            <app-trash-icon
              class="clickable cancellation-document__remove"
              height="16px"
              width="16px"
              color="var(--gray-400)"
              role="button"
              tabindex="0"
              title="Supprimer"
              i18n-title
              (click)="confirmDelete(cancellation, document)"
              (keydown.enter)="confirmDelete(cancellation, document)"
              (keydown.space)="confirmDelete(cancellation, document)"
            />
          }
        </li>
      }
    }
  </ul>
</app-expansion-panel>

<app-pdf-viewer-modal #pdfViewer />

<app-cancellation-document-modal
  #documentModal
  (changed)="cancellationChanged.emit($event)"
  (policyAdded)="onPolicyDocumentAdded()"
/>

<app-action-modal #deleteModal [disabled]="deleting" (submitted)="remove()">
  <ng-container mainTitle i18n>Supprimer ce document ?</ng-container>
  <ng-container subtitle i18n>Cette action est irréversible</ng-container>
  <ng-container submitButtonLabel i18n>Supprimer</ng-container>
</app-action-modal>
